import {Component} from '@angular/core';
import {AlertController, NavParams, ViewController} from 'ionic-angular';

import {ControlesInternosService} from '../../../../providers/controles-internos-service';

/*
  Generated class for the ModuloAnalise page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-modal-pv-controles-internos',
  templateUrl: 'modal-pv-controles-internos.html',
  providers: [
    ControlesInternosService
  ]
})
export class ModalPreVisualizarControlesInternoPage {
  titulo: any;
  isJurisdicionado: any;
  categoriasControlesInternos: any = [];
  shownGroup: any;
  mediaRespostas: number = 0;
  PCAAtiva: any;
  loading: boolean = true;

  constructor(private viewCtrl: ViewController, public navParams: NavParams, public controlesInternosService: ControlesInternosService,public alertCtrl: AlertController) {
    this.carregarInformacoes();
  }

  carregarInformacoes() {
    this.mediaRespostas = this.navParams.get('mediaRespostas');
    this.PCAAtiva = this.navParams.get('PCAAtiva');

    this.controlesInternosService.obterQuestoesCertificadoPCA().subscribe(data => {
      this.categoriasControlesInternos = data;

      this.categoriasControlesInternos.map((categoria) => {
        return categoria.perguntas.map((questao) => {
          return questao;
        });
      });
      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
    });
  }

  toggleGroup(group) {
    if (this.isGroupShown(group)) {
      this.shownGroup = null;
    } else {
      this.shownGroup = group;
    }
  }
  isGroupShown(group) {
    return this.shownGroup === group;
  };

  verificarSeCategoriaPossuiPerguntas()
  {
    let algumaCategoriaPossuiPerguntas = true;

    this.categoriasControlesInternos.forEach(categoria => {
        if(categoria.perguntas.length > 0)
        {
          algumaCategoriaPossuiPerguntas = false;
        }
    });

    return algumaCategoriaPossuiPerguntas;
  }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-pre-visualizacao/controles-internos/modal-pv-controles-internos.ts